import { IntlMessageFormat } from 'intl-messageformat';

/** Creates a text-only ICU message using the same policy in Angular and Node build scripts. */
export function createTextMessage(value, lang) {
  if (/<\/?[A-Za-z][\w:.-]*(?:\s[^<>]*|\s*\/?)>/.test(value)) {
    throw new SyntaxError('HTML-like tags are not allowed in text translations');
  }
  Intl.getCanonicalLocales(lang);
  // The ICU parser rejects unescaped legacy {{placeholders}} without rejecting
  // valid adjacent braces in nested ICU branches or escaped literal braces.
  return new IntlMessageFormat(value, lang);
}
